angular.module('natura', ['ngeo', 'ngAnimate', 'ngSanitize', 'ngRoute', 'ui.bootstrap', 'ui.select', 'ngMaterial',
    'ngMessages', 'ngFileSaver'
]);
